import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PreviewButtonWrapper = styled(Box)({
  marginRight: 16,
});

export const PreviewButton = styled(Button)({
  fontSize: '12px',
  textTransform: 'none',
  padding: '0 10px',
  width: 84,
  height: 28,
  lineHeight: 1,
  minHeight: 'unset',
  color: 'var(--am-ghost-btn-color) !important',
  border: 'var(--am-ghost-btn-border) !important',
  '&:hover': {
    backgroundColor: 'transparent',
  },
});
